// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AssessmentComment_wrapper__22DUI","listComment":"AssessmentComment_listComment__2lBFh","commentDetail":"AssessmentComment_commentDetail__1uy2B"};